
import React, { useState } from 'react';
import BackButton from "../widgets/BackButton";

import { AcceptAwardOfferApi } from "../../util/api/ServiceObjects/AcceptAwardOfferApi";

import "../forms/style/checkbox.css"



let ConfirmAward = ({ ...props }) => {
    props.store.updateBanner(`Accept Award`);


    const accountId = props.accountId;

    const [checkBoxValue, setcheckBoxValue] = useState(false);

    const acceptAwardOffer = async () => {
        await AcceptAwardOfferApi.update(accountId);
        await props.store.getFromApi();
    }

    
    //buttons
    //Go back   //Go to TuPortal       //Confirm (disabled={this.checkBoxSelected})
    return (
        <div>
            <p>Before you begin your summer work study, you must accept your Summer Work Study award on TUPortal.</p>

            <p>To accept your award, navigate to TUPortal and follow the steps below:</p>

            <ol>
                <li>Go to the Cost & Aid Tab</li>
                <li>Click on Financial Aid</li>
                <li>Select the 2023-2024 award year</li>
                <li>Accept the Federal Work Study award</li>
            </ol>

            <p>Once you confirm your grant is accepted, you may proceed.</p>

            <div className="w-100 d-flex justify-content-center">
                <div className="d-flex w-80 justify-content-center pt-3" style={{backgroundColor: "rgb(242, 238, 232)"}}>
                    
                    <div className="mr-3 ml-4">
                        <p><i>I have read the above and acknowledge that I have accepted my award amount on TUPortal</i></p>
                    </div>
                    <div className="pr-4">
                        <input 
                            className="myinput large"
                            type="checkbox" 
                            name="acknowledgement"
                            onChange={() => setcheckBoxValue(!checkBoxValue)} 
                            checked={checkBoxValue}
                        />
                    </div>
                </div>
            </div>

            <div className="d-flex flex-row mt-4">
                <BackButton className="btn btn-secondary" innerText={"Go Back"} />
                
                <a className="btn ml-2 btn-primary" href="https://tuportal.temple.edu" target="_blank">
                    Go To TUPortal
                </a>

                <button className="btn btn-primary ml-auto" onClick={acceptAwardOffer} disabled={!checkBoxValue}>
                    Confirm
                </button>
            </div>
        </div>
    )
}

export default ConfirmAward;